module.exports = __webpack_public_path__ + "img/phone-store-mob.e563c311.webp";